import { Avatar, Button, Col, Form, Input, Modal, Radio, Row, Select, Space, Upload } from 'antd';
import React, { useEffect, useState } from 'react';
import { UserOutlined } from '@ant-design/icons';
import EventEmitter from '../../utils/eventEmitter';


const MyFooter = ({ handleSaveNew, handleSaveClose, handleCancel }) => {
  return (
    <div className='flex border-t-2 pt-2'>
      <Button className='me-3' onClick={handleSaveNew} type='primary'>Save and New</Button>
      <Button className='me-3' onClick={handleSaveClose} type='primary'>Save and Close</Button>
      <Button onClick={handleCancel} danger>Discard</Button>
    </div>
  )
};



const ContactAddress = () => {
  const [form] = Form.useForm();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleCancel = () => setIsModalOpen(false);
  
  const handleSaveClose = () => { };

  const handleSaveNew = () => { };



  useEffect(() => {
    EventEmitter.subscribe('create_contact_modal_open', data => setIsModalOpen(data));
    return () => EventEmitter.unsubscribe('create_contact_modal_open');
  },[])


  return (
    <Modal title={<h3 className='border-b-2'>Create Contact</h3>} width={1000} className='p-0 ' open={isModalOpen} onCancel={handleCancel} footer={<MyFooter handleCancel={handleCancel} handleSaveNew={handleSaveNew} handleSaveClose={handleSaveClose}/>}>
      <Form
        form={form}
        className='pt-2' 
        labelAlign='left'
        labelCol={{span: 7}}
        initialValues={{  }}
        autoComplete="off"
        variant='borderless'
      >
        <Row className='mb-3 border-b-2 pb-3'>
          <Col md={{span: 3}} lg={{span: 4}}>
            <Radio value={'contact'}>Contact</Radio>
          </Col>
          <Col md={{span: 3}} lg={{span: 4}}>
            <Radio value={'contact'}>Invoice Address</Radio>
          </Col>
          <Col md={{span: 3}} lg={{span: 4}}>
            <Radio value={'contact'}>Delivery Address</Radio>
          </Col>
          <Col md={{span: 3}} lg={{span: 4}}>
            <Radio value={'contact'}>Private Address</Radio>
          </Col>
          <Col md={{span: 3}} lg={{span: 4}}>
            <Radio value={'contact'}>Other Address</Radio>
          </Col>
        </Row>
        <Row>
          <Col md={{span: 20}} lg={{span: 10}}>
            <Form.Item label='Contact Name' name={'name'} className='font-bold mb-1' required>
              <Input type='text' className='input-outline-none font-normal' />
            </Form.Item>
            <Form.Item label='Address' className='font-bold mb-1' required >
              <Space.Compact direction='vertical'>
                <Form.Item name={['address', 'street1']} noStyle>
                  <Input type='text' className='input-outline-none font-normal' placeholder='street 1' name='street1'/>
                </Form.Item>
                <Form.Item name={['address', 'street2']} noStyle>
                  <Input type='text' className='input-outline-none font-normal' placeholder='street 2' name='street2' />
                </Form.Item>
              </Space.Compact>
              <Row>
                <Col md = {{span: 11}}>
                  <Form.Item name={['address', 'region']} noStyle>
                    <Select options={[]} placeholder='region' name='region' className='font-normal' />
                  </Form.Item>
                </Col>
                <Col md = {{span: 11, offset: 2}}>
                  <Form.Item name={['address', 'city']} noStyle>
                    <Select options={[]} placeholder='city' name='city' className='font-normal'/>
                  </Form.Item>
                </Col>
              </Row>
            </Form.Item> 
            <Form.Item label='Notes' name="notes" className='font-bold mb-1' required>
              <Input type='text' className='input-outline-none font-normal' placeholder='internal notes...'/>
            </Form.Item>
          </Col>
          <Col md={{span: 20}} lg={{span: 8, offset: 1}}>
            <Form.Item label='Email' name="email" className='font-bold mb-1' required>
              <Input type='email' className='input-outline-none font-normal' placeholder=''/>
            </Form.Item>
            <Form.Item label='Phone' name="phone_number1" className='font-bold mb-1' required>
              <Input type='tel' className='input-outline-none font-normal' placeholder=''/>
            </Form.Item>
            <Form.Item label='Mobile' name="phone_number2" className='font-bold mb-1' required>
              <Input type='tel' className='input-outline-none font-normal' placeholder=''/>
            </Form.Item>
          </Col>
          <Col md={{span: 10, offset: 1}} lg={{span: 4}}>
            <Upload 
              name="picture"
              listType="picture-card"
              className="avatar-uploader"
              showUploadList={false}
              style={{height: '30px'}}
              
            >
              <Avatar icon={<UserOutlined />} />
            </Upload>
          </Col>
        </Row>
      </Form>
    </Modal>
  )
}

export default ContactAddress;